import PropTypes from "prop-types";
import { InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";

function SearchInput({
  onChange,
  value,
  className,
  disableImg,
  placeholder,
  label,
  color,
  name,
}) {
  return (
    <div className="input-container">
      <TextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
        className={` ${className}`}
        color={color}
        label={label}
        name={name}
        placeholder={placeholder}
        size="small"
        sx={{
          borderRadius: 1,
          width: "100%",
        }}
        type="text"
        value={value}
        variant="filled"
        onChange={onChange}
      />
    </div>
  );
}

SearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  disableImg: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  name: PropTypes.string,
};

SearchInput.defaultProps = {
  disableImg: false,
  placeholder: "",
  label: "",
  color: "primary",
  name: "",
};

export default SearchInput;
